function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}

/** Default brand logo for Open Graph / Twitter / JSON-LD (480w WebP). Legacy PNG remains in `public/` unused by default. */
export const BRAND_LOGO_PATH = '/rentabahay-logo.webp';

/**
 * Canonical / Open Graph / JSON-LD origin.
 *
 * - Prefer `VITE_PUBLIC_SITE_URL` when set (any deploy: production, staging, branch).
 * - Else use the browser origin only on local dev (localhost / .local) so links work.
 * - Else default to production. Netlify branch deploys must NOT use `window.location.origin`
 *   here or you get a second canonical (e.g. `*.netlify.app`) conflicting with production SEO.
 */
export function getSiteOrigin(): string {
  const raw = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;
  if (raw && /^https?:\/\//i.test(raw.trim())) {
    return stripTrailingSlash(raw.trim());
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
      return stripTrailingSlash(window.location.origin);
    }
  }
  return 'https://rentabahay.com';
}

/** Absolute URL for this deployment (path must start with `/` unless it is already absolute). */
export function absoluteSiteUrl(pathOrUrl: string): string {
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
    return pathOrUrl;
  }
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${getSiteOrigin()}${path}`;
}
